export default "__VITE_ASSET__b5da86bd__"